import { Injectable } from '@angular/core';
import { Router, CanActivate, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Http, Headers, URLSearchParams, QueryEncoder } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/map';

import { AppConfigService } from '../app.config';

@Injectable()
export class AuthGuard implements CanActivate {
  redirectUrl: string;

constructor(private router: Router,
    private http: Http,
    private config: AppConfigService) {}

    _error$: Subject<any> = <Subject<any>>new Subject();
    get error$() { return this._error$.asObservable(); }

    _auth$: Subject<string> = <Subject<string>>new Subject();
    get auth$() { return this._auth$.asObservable(); }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

        if(this.config.token)
            return true;

        this.redirectUrl = state.url;
        this.router.navigate(['/login']);

        return false;
    }

    login(key: string) {
        this.http.post(`${this.config.url}/auth`, JSON.stringify({apiKey: btoa(key)}),
        { headers: contentHeaders }).map((response: any) => response.status === 204 ? null : response.json())
          .subscribe(
            (response) => {
                localStorage.setItem('auth-key',response.token);
                let url = '/search';
                console.log('redirect', this.redirectUrl);
                if(this.redirectUrl && this.redirectUrl.indexOf('login') == -1 && this.redirectUrl != '/')
                    url = this.redirectUrl;
                
                this._auth$.next(url);
            },
            error => {
                this._error$.next(error);
              }
          );
    }

    logout() {
        localStorage.removeItem('auth-key');
    }
}

export const contentHeaders = new Headers();
contentHeaders.append('Accept', 'application/json');
contentHeaders.append('Content-Type', 'application/json');



// WEBPACK FOOTER //
// ./src/app/services/auth-guard.ts